module.exports = __webpack_public_path__ + "static/media/0004.e35e87c0.jpg";